import React from "react";
// import history from "../History";
// import { Text } from "react-internationalization";

const LoginBanner = (props) => {
  const { header, Body } = props;
  return (
    <div>
      <div class="jumbotron-web jumbotron-web-height">
        <div class="enroll-header-content enroll-header-content-large enroll-header-bg">
          <div class="enroll-header-content-width">
            {header.length > 0 ? <h2>{header}</h2> : null}
            <div>
              <Body />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginBanner;
